import { useContext } from 'react';
import { BaasAccountContext } from '@/contexts/BaasAccountContext';

const useBaasAccount = () => {
  const context = useContext(BaasAccountContext);

  if (!context) {
    throw new Error('useBaasAccount must be used within BaasAccountProvider');
  }

  return context;
};

export default useBaasAccount;

